import './instagram_media_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramStoryContent extends Monitoring.Models.SocialContents.InstagramMediaContent

  isBrandContent: ->
    @author().fb_id == @data().instagram_business_integration_id

  getRootParentId: ->
    null
